<template>
    <div>
        <Modal v-model="isShowModal" :title="title" @on-cancel="hide()" :mask-closable="false" width="950">

            <Divider orientation="left">订单信息</Divider>
            <Row :gutter="16">
                <Col span="8">
                    <div>订单编号：{{orderInfo.order.orderCode}}</div>
                </Col>
                <Col span="16">
                    <div>订单标题：{{orderInfo.order.orderTitle}}</div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="8">
                    <div>下单昵称：{{orderInfo.order.nickName}}</div>
                </Col>
                <Col span="8">
                    <div>订单总额：环保金{{orderInfo.order.integral}}</div>
                </Col>
                <Col span="8">
                    <div>商品总额：环保金{{orderInfo.order.integral}}</div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="8">
                    <div>
                        订单状态：
                        <template v-if="orderInfo.order.orderState == 1 && orderInfo.orderLogistics.logisticsCode">已完成
                        </template>
                        <template v-if="orderInfo.order.orderState == 1 && !orderInfo.orderLogistics.logisticsCode">待发货
                        </template>
                        <template v-if="orderInfo.order.orderState == 2">已取消</template>
                    </div>
                </Col>
                <Col span="8">
                    <div>创建时间：{{orderInfo.order.createTime}}</div>
                </Col>
            </Row>
            <Divider orientation="left">支付信息</Divider>
            <Row :gutter="16">
                <Col span="8">
                    <div>支付环保金：{{orderInfo.order.integral?orderInfo.order.integral:0}}</div>
                </Col>
            </Row>
            <Divider orientation="left">物流信息</Divider>
            <Row :gutter="16">
                <Col span="8">
                    <div>收货人姓名：{{orderInfo.orderLogistics.consigneeName}}</div>
                </Col>
                <Col span="8">
                    <div>收货人手机号：{{orderInfo.orderLogistics.consigneePhone}}</div>
                </Col>
                <Col span="8">
                    <div>收货人地址：{{orderInfo.orderLogistics.consigneeAddress}}</div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="8">
                    <div>物流公司：{{orderInfo.orderLogistics.logisticsName ? orderInfo.orderLogistics.logisticsName:'-'}}
                    </div>
                </Col>
                <Col span="8">
                    <div>物流公司代码：{{orderInfo.orderLogistics.logisticsCode ? orderInfo.orderLogistics.logisticsCode:'-'}}
                    </div>
                </Col>
                <Col span="8">
                    <div>物流单号：{{orderInfo.orderLogistics.logisticsNum ? orderInfo.orderLogistics.logisticsNum:'-'}}</div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="8">
                    <div>发货时间：{{orderInfo.orderLogistics.sendTime ? orderInfo.orderLogistics.sendTime:'-'}}</div>
                </Col>
                <Col span="16">
                    <div>收货时间：{{orderInfo.orderLogistics.getTime ? orderInfo.orderLogistics.getTime:'-'}}</div>
                </Col>
            </Row>
            <Divider orientation="left">商品信息</Divider>
            <Row>
                <Col span="24">
                    <div class="j-order-image">
                        <div class="j-order-image-main">
                            <img :src="orderInfo.order.orderImages">
                        </div>
                        <div class="j-order-image-info">
                            <div class="j-order-goods-title">{{orderInfo.order.goodsName}}</div>
                            <div class="j-order-goods-price">环保金：{{orderInfo.order.integral}}</div>
                            <div class="j-order-goods-num">数量：x1</div>
                        </div>
                    </div>
                </Col>
            </Row>

            <!-- 重写对话框底部按钮 -->
            <div slot="footer">
                <Button @click="hide('formValidate')">取消</Button>
                <Button type="primary" @click="hide()" :loading="loadingBtn">
                    <span v-if="!loadingBtn">确定</span>
                    <span v-else>请稍候...</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: "order-ope",
        data() {
            return {
                isShowModal: false,
                loadingBtn: false,
                orderInfo: {
                    order: {},
                    orderLogistics: {},
                    logistics: ''
                },
                goodsSkuInfo: {},
                title: '订单详情'
            }
        },
        methods: {
            // 显示模态框
            show(row) {
                this.isShowModal = true;
                this.getInfo(row);
            },
            // 查询订单详情
            getInfo(row) {
                this.$Spin.show();
                this.axios.post('/convertibleOrder/getInfo', {
                    convertibleOrderId: row.convertibleOrderId
                }).then(res => {
                    console.log(res);
                    setTimeout(() => {
                        this.$Spin.hide();
                    }, 300);
                    if (res.status == 200) {
                        // this.$Message.success('操作成功.');
                        this.orderInfo = res.data;
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '查看订单详情接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 关闭模态框
            hide() {
                this.isShowModal = false;
            }
        }
    }
</script>

<style scoped lang="less">
    .j-order-image {
        display: flex;

        .j-order-image-main {
            width: 130px;
            height: 130px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .j-order-image-info {
            margin-left: 10px;

            .j-order-goods-sku {
                margin-top: 5px;
            }

            .j-order-goods-price {
                margin-top: 5px;
            }

            .j-order-goods-num {
                margin-top: 5px;
            }
        }
    }

</style>